import "./list";

$(function() {

	$.fn.recipesRefresh = function() {
		let list = $(this);
		let params = {
			fields: {
				templates: [
					'grid.standard',
				],
			},
		};

		// Query
		params.query = $(this).find('[name="query"]').val().trim();

		// Tags.
		params.tagIds = [];
		$(this).find('[data-tag-id]:checked').each(function() {
			params.tagIds.push(parseInt($(this).attr('data-tag-id')));
		});

		// Ranges.
		params.ranges = {};
		$(this).find('.range-slider').each(function() {
			params.ranges[$(this).find('.slider-item').attr('id')] = {
				min: $(this).find('[data-id="' + $(this).find('.slider-item').attr('id') + '-0"]').val(),
				max: $(this).find('[data-id="' + $(this).find('.slider-item').attr('id') + '-1"]').val(),
			};
		});

		// Difficulties.
		params.difficulties = [];
		$(this).find('[data-difficulty]:checked').each(function() {
			params.difficulties.push(parseInt($(this).attr('data-difficulty')));
		});

		// Without allergens.
		params.excludeAllergenIds = [];
		$(this).find('[data-allergen]:checked').each(function() {
			params.excludeAllergenIds.push(parseInt($(this).attr('data-allergen')));
		});

		// Can be frozen.
		params.canBeFrozen = [];
		$(this).find('[data-can-be-frozen]:checked').each(function() {
			params.canBeFrozen.push(parseInt($(this).attr('data-can-be-frozen')));
		});

		// Macronutrients.
		$(this).find('[name="makronutrienty"]:checked').each(function() {
			params.macronutrients = {
				fats: {
					min: $(this).attr('data-fats-min'),
					max: $(this).attr('data-fats-max'),
				},
				carbs: {
					min: $(this).attr('data-carbs-min'),
					max: $(this).attr('data-carbs-max'),
				},
				proteins: {
					min: $(this).attr('data-proteins-min'),
					max: $(this).attr('data-proteins-max'),
				},
			};
		});

		$(this).listSetParams(params);
		$(this).listSetSort($(this).find('[name="sorting"]:checked').val());
		$(this).listReload(function(response) {
			$('.filtering .num .number').html(response.pagination.total);
			try {
				if (response.richFilterCount) {
					$('.filtering > .cancel').removeClass('hidden');
				} else {
					$('.filtering > .cancel').addClass('hidden');
				}
			} catch (e) {}
		});
	}

	document.addEventListener("recipes.filtersChanged", function(e) {
		$('[data-list="recipes"]').recipesRefresh();
	});

});
